const REACT_CONFIG = Object.keys(process.env).reduce((sum, key) => {
  if (key.includes('REACT_APP')) {
    try {
      sum[key] = process.env[key] && JSON.parse(process.env[key]);
    } catch (e) {
      sum[key] = process.env[key];
    }
  }
  return sum;
}, {});

export default REACT_CONFIG;
